import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { getCarts, loadCartByUrl, removeCart } from "../actions/cartActions";
import { setPager } from "../actions/pagerActions";
import { withRouter } from "react-router";
import { utils } from "../common/utils";
import { Breakpoint } from 'react-socks';
import { withTranslation } from 'react-i18next';
import Cart from "./Cart";
import NewWindow from "../components/NewWindow";
import { showSuccess, showError } from "../common/iziToast";
import * as Icons from "../common/icons";
import ConfirmDialog from "../components/ConfirmDialog";

class CartList extends Component {

    state = {
        visibleWindow: false,
        selectedCart: { cartJson: '""', name: '' },
        cartUrlToRemove: 0
    };

    onCloseWindow = () => {
        this.setState({ visibleWindow: false });
    };

    componentDidMount() {
        const { user } = this.props;
        if (user.isAuthenticated) {
            this.props.getCarts(user.userId);
        }
    }

    onRowClick(cartUrl) {
        this.props.loadCartByUrl(cartUrl).then((response) => {
            this.onSelectCart(response.value.data);
            //  utils.scrollTop();
        }, (error) => {
            console.log(error)
        });
    }

    onRemoveCart(event, cartUrl) {
        this.setState({ cartUrlToRemove: cartUrl });
        event.preventDefault();
        event.stopPropagation();
    }

    onCancelRemoveCart() {
        this.setState({ cartUrlToRemove: 0 });
    }

    removeCart() {
        const { user, t } = this.props;
        const { cartUrlToRemove } = this.state;
        this.props.removeCart(user.userId, cartUrlToRemove).then((response) => {
            if (response.value.status === 200) {
                this.setState({ cartUrlToRemove: 0 });
                showSuccess(t("Remove Cart"), `${t("Cart removed successfuly")}`, Icons.CART);
            } else {
                showError(t("Remove Cart"), `${t("Unable to remove cart. please try again later")}`, Icons.CART);
            }

        }, (error) => {
            showError(t("Remove Cart"), `${t("Unable to remove cart. please try again later")}`, Icons.CART);
        });
        //event.preventDefault();
        //event.stopPropagation();
    }


    onSelectCart(cart) {
        cart.lines = JSON.parse(cart.cartJson);
        this.setState({
            selectedCart: cart,
            visibleWindow: true
        });
    }

    render() {
        const { t, carts, user } = this.props;

        if (!carts || carts.items.length === 0 || !user.isAuthenticated)
            return (<div className="alert alert-info fade show text-center margin-bottom-1x">
                <span className="alert-close" data-dismiss="alert"></span>
                <i className="icon-layers"></i>&nbsp;&nbsp;<strong>{t("My Carts")}:</strong> {t("You don't have any carts")}.
            </div>);

        return (
            <Fragment>
                <NewWindow title={`${t("Cart")}: ${this.state.selectedCart.name}`} open={this.state.visibleWindow} onClose={this.onCloseWindow.bind(this)}>
                    <Cart isReadOnly={true} showCartShareActions={true} selectedCart={this.state.selectedCart} />
                </NewWindow>
                <ConfirmDialog title={t("Remove Cart")} open={(this.state.cartUrlToRemove !== 0)} message={t("Are you sure you want to remove the cart?")}
                    yesTitle={t("Yes")} onYes={() => this.removeCart()} onNo={() => this.onCancelRemoveCart()} />
                <Breakpoint small down>
                    <div className="card">
                        <div className="card-header" role="tab">
                            <h6>
                                {t("My Carts")}
                            </h6>
                        </div>
                        <div className="card-body">
                            <nav className="list-group">
                                {carts.items.map(o => (


                                    <div className="list-group-item d-flex justify-content-between m-1" key={o.id}>
                                        <a className="text-medium navi-link" onClick={() => this.onRowClick(o.url)}> {o.name} </a>
                                        <button
                                            onClick={(e) => this.onRemoveCart(e, o.url)}
                                            className="remove-icon btn btn-link pr-0"
                                            data-toggle="tooltip"
                                            title={t("Remove Cart")} >
                                            <i className="icon-cross" />
                                        </button>
                                    </div>

                                ))}
                            </nav>
                        </div>
                    </div>
                </Breakpoint>
                <Breakpoint medium up>
                    <div className="padding-top-2x mt-2 hidden-lg-up"></div>
                    <div className="table-responsive">
                        <table className="table table-hover margin-bottom-none">
                            <thead>
                                <tr>
                                    {/* <th>{t("Cart #")}</th>*/}
                                    <th>{t("Name")}</th>
                                    <th>{t("Date Created")}</th>
                                    <th> </th>
                                </tr>
                            </thead>
                            <tbody>
                                {carts.items.map(o => (
                                    <tr key={o.id} onClick={() => this.onRowClick(o.url)} className='clickable'>
                                        {/* <td><a className="text-medium navi-link" href={null} role="button" data-toggle="modal" data-target="#cartDetails">{o.id}</a></td>*/}
                                        <td><span className="text-medium navi-link">{o.name}</span></td>
                                        <td>{utils.dates.getDateTime24String(o.createdAt)}</td>
                                        <td>
                                            <button
                                                onClick={(e) => this.onRemoveCart(e, o.url)}
                                                className="remove-icon btn btn-link"
                                                data-toggle="tooltip"
                                                title={t("Remove Cart")} >
                                                <i className="icon-cross" />
                                            </button>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Breakpoint>
            </Fragment>
        );
    }
}

function mapStateToProps({ carts, settings, user }, ownProps) {
    return { carts, settings, user, ...ownProps };
}

export default withTranslation()(withRouter(
    connect(mapStateToProps, { getCarts, loadCartByUrl, removeCart, setPager })(CartList))
);
